var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.125C9.09375 1.125 6.35625 2.25 4.3125 4.3125C2.25 6.35625 1.125 9.09375 1.125 12C1.125 14.9062 2.25 17.6437 4.3125 19.6875C6.375 21.75 9.09375 22.875 12 22.875C14.9062 22.875 17.6437 21.75 19.6875 19.6875C21.75 17.625 22.875 14.9062 22.875 12C22.875 9.09375 21.75 6.35625 19.6875 4.3125C17.6437 2.25 14.9062 1.125 12 1.125ZM18.9 18.9C17.0438 20.7375 14.6062 21.75 12 21.75C9.39375 21.75 6.95625 20.7375 5.1 18.9C3.24375 17.0625 2.25 14.6062 2.25 12C2.25 9.39375 3.2625 6.95625 5.1 5.1C6.9375 3.24375 9.39375 2.25 12 2.25C14.6062 2.25 17.0438 3.2625 18.9 5.1C20.7563 6.9375 21.75 9.39375 21.75 12C21.75 14.6062 20.7375 17.0438 18.9 18.9Z",
    fill: "#9BA3AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6V12L16 16",
    stroke: "#9BA3AB",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.832ae4cfc85a3f85acdaba3550054b42.svg";
export { ForwardRef as ReactComponent };